import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpParams } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { Subject } from 'rxjs';
import { CommonService } from '../../common.service';
import { NgxSpinnerService } from "ngx-spinner";
import { CommonVariablesService } from '../../common-variables.service';
import * as XLSX from 'xlsx'

@Component({
  selector: 'app-country-settling-agent-mapping',
  templateUrl: './country-settling-agent-mapping.component.html',
})
export class CountrySettlingAgentMappingComponent implements OnInit {
  countrySettlingAgentMappingForm: FormGroup;
  dtTrigger: Subject<any> = new Subject();
  dtOptions: any;
  submitted = false;
  displayCountrySettlingAgentMappingResponse: any;
  countrySettlingAgentMappingFormValue: any;
  countryID: any;
  btnAddShow = false;
  btnUpdateShow = true;
  isViewMode: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private datePipe: DatePipe,
    private commonVariablesService: CommonVariablesService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
	window.localStorage.setItem('pageName','');
    this.countrySettlingAgentMappingForm = this.formBuilder.group({
      countryCode: ['', Validators.required],
      countryName: ['', Validators.required],
      cityName: [''],
      companyName: ['', Validators.required],
      address: ['', Validators.required],
      phoneNo: ['', [Validators.required, Validators.pattern('^(?!0*$).*$')]],
      alternatePhoneNo: [''],
      faxNo: [''],
      TelexNo: [''],
      emailId: ['', [Validators.required, Validators.pattern('^(.+)@(.+)$')]],
      tabrowindx: [''],
      settling_Agent_Name: ['', Validators.required],
      GC_country_name: ['', Validators.required],
      settling_Agent_Code: ['', Validators.required],
      referralSelect: ['', Validators.required],
      txtFile: ['']
    });

    this.dtOptions = {
      dom: 'frtip',
      "pageLength": 50
    };
    
    /* let tmpUserType = this.cookie.get('userProfile'); */
    let tmpUserType = window.localStorage.getItem('userProfile');
    const getUserType = this.commonService.decryptData(tmpUserType);
    this.isViewMode = ((getUserType || '').toLowerCase() == 'adminview');

    this.loadCountrySettlingAgentMappingDetails();
  }

  get f() { return this.countrySettlingAgentMappingForm.controls; }

  /*
  * Created By : Keerthana
  * Description : This function will fetch the details of the country settling agent mapping.
  *********************************************/

  async loadCountrySettlingAgentMappingDetails() {
    this.spinner.show();
    let table = $('#countrySettlingAgentMappingDatatable').DataTable();
    table.destroy();
    let fetchUrl = this.commonVariablesService.baseURL + 'api/v1/marine_master/fetchall/country';
    let tblData = await this.commonService.httpGetMethod(fetchUrl, 'application/x-www-form-urlencoded', true, '', 'Country Master');
    this.displayCountrySettlingAgentMappingResponse = [];

    if (tblData.status == 0) {
      for (var i = 0; i < tblData.data.length; i++) {
		  tblData.data[i].u_ts = this.datePipe.transform(new Date(tblData.data[i].u_ts+" GMT").toISOString(),"dd-MM-yyyy HH:mm:ss")
        this.displayCountrySettlingAgentMappingResponse.push(tblData.data[i]);
      }
    }
    else if (tblData.status != -114) {
      this.commonService.errorsmsg('Fetch Error', 'Error');
    }

    $('#searchCountryCode,#searchCountryName,#searchCityName,#searchCompanyName,#searchAddress,#searchPhoneNo,#searchAlternatePhoneNo,#searchFaxNo,#searchTelexNo,#searchEmailId,#searchTabrowindx,#searchSettlingAgentName,#searchGCCountryName,#searchSettlingAgentCode,#searchReferral,#searchUpdatedBy,#searchUpdatedTime').val('');
    this.dtTrigger.next();
  }

  /*
  * Created By : Keerthana
  * Description : This function will add the detail in the country settling agent mapping.
  *********************************************/

  async addCountrySettlingAgentMappingDetails() {
     
    let ret = await this.checkCountryMappingMasterData();
    if (!ret) return;

    this.spinner.show();
    let addUrl = this.commonVariablesService.baseURL + 'api/v1/marine_master/add/country';
    let param = new HttpParams()
      .set('code', this.countrySettlingAgentMappingFormValue.countryCode)
      .set('country', this.countrySettlingAgentMappingFormValue.countryName)
      .set('city', this.countrySettlingAgentMappingFormValue.cityName || '')
      .set('company', this.countrySettlingAgentMappingFormValue.companyName)
      .set('address', this.countrySettlingAgentMappingFormValue.address)
      .set('phone', this.countrySettlingAgentMappingFormValue.phoneNo)
      .set('alt_phone', this.countrySettlingAgentMappingFormValue.alternatePhoneNo || '')
      .set('fax', this.countrySettlingAgentMappingFormValue.faxNo || '')
      .set('telex', this.countrySettlingAgentMappingFormValue.TelexNo || '')
      .set('email', this.countrySettlingAgentMappingFormValue.emailId)
      .set('tabrowindx', this.countrySettlingAgentMappingFormValue.tabrowindx || '')
      .set('agent_name', this.countrySettlingAgentMappingFormValue.settling_Agent_Name)
      .set('gc_country_name', this.countrySettlingAgentMappingFormValue.GC_country_name)
      .set('agent_code', this.countrySettlingAgentMappingFormValue.settling_Agent_Code)
      .set('referral', this.countrySettlingAgentMappingFormValue.referralSelect);
    let addResponse = await this.commonService.httpPostMethod(addUrl, param, 'application/x-www-form-urlencoded; charset=UTF-8', true, 'Country Master');

    if (addResponse.body.status == 0) {
      this.commonService.successmsg('Country settling agent mapping data added successfully', 'Success');
      this.loadCountrySettlingAgentMappingDetails();
      this.resetForm();
    }
    else if (addResponse.body.status != -114) {
      this.commonService.errorsmsg('Unable to add country settling agent mapping data', 'Error');
    }
  }

  /*
  * Created By : Keerthana
  * Description : This function will edit the detail in the country settling agent mapping.
  *********************************************/

  editCountrySettlingAgentMappingDetails(oldResponse) {
    this.btnAddShow = true;
    this.btnUpdateShow = false;
    this.countrySettlingAgentMappingForm.patchValue({
      countryCode: oldResponse.country_code,
      countryName: oldResponse.country_name,
      cityName: oldResponse.city_name,
      companyName: oldResponse.company_name,
      address: oldResponse.address,
      phoneNo: oldResponse.phone_no,
      alternatePhoneNo: oldResponse.alt_phone_no,
      faxNo: oldResponse.fax_no,
      TelexNo: oldResponse.telex_no,
      emailId: oldResponse.email_id,
      tabrowindx: oldResponse.tabrowindx,
      settling_Agent_Name: oldResponse.setling_agent_name,
      GC_country_name: oldResponse.gc_country_name,
      settling_Agent_Code: oldResponse.settling_agent_code,
      referralSelect: oldResponse.referral,
      txtFile: ['']
    });
    this.countryID = oldResponse.country_id;
  }

  /*
  * Created By : Keerthana
  * Description : This function will update the detail in the country settling agent mapping.
  *********************************************/

  async updateCountrySettlingAgentMappingDetails() {
    
    let ret = await this.checkCountryMappingMasterData();
    if (!ret) return;
  
    this.spinner.show();
    let updateUrl = this.commonVariablesService.baseURL + 'api/v1/marine_master/update/country';
    let param = new HttpParams()
      .set('code', this.countrySettlingAgentMappingFormValue.countryCode)
      .set('country', this.countrySettlingAgentMappingFormValue.countryName)
      .set('city', this.countrySettlingAgentMappingFormValue.cityName || '')
      .set('company', this.countrySettlingAgentMappingFormValue.companyName)
      .set('address', this.countrySettlingAgentMappingFormValue.address)
      .set('phone', this.countrySettlingAgentMappingFormValue.phoneNo)
      .set('alt_phone', this.countrySettlingAgentMappingFormValue.alternatePhoneNo || '')
      .set('fax', this.countrySettlingAgentMappingFormValue.faxNo || '')
      .set('telex', this.countrySettlingAgentMappingFormValue.TelexNo || '')
      .set('email', this.countrySettlingAgentMappingFormValue.emailId)
      .set('tabrowindx', this.countrySettlingAgentMappingFormValue.tabrowindx || '')
      .set('agent_name', this.countrySettlingAgentMappingFormValue.settling_Agent_Name)
      .set('gc_country_name', this.countrySettlingAgentMappingFormValue.GC_country_name)
      .set('agent_code', this.countrySettlingAgentMappingFormValue.settling_Agent_Code)
      .set('referral', this.countrySettlingAgentMappingFormValue.referralSelect)
      .set('id', this.countryID);
    let response = await this.commonService.httpPostMethod(updateUrl, param, 'application/x-www-form-urlencoded; charset=UTF-8', true, 'Country Master');

    if (response.body.status == 0) {
      this.commonService.successmsg('Country settling agent mapping data updated successfully', 'Success');
      this.loadCountrySettlingAgentMappingDetails();
      this.resetForm();
    }
    else if (response.body.status != -114) {
      this.commonService.errorsmsg('Unable to update country settling agent mapping data', 'Error');
    }
  }

  /*
  * Created By : Keerthana
  * Description : This function will delete the detail in the country settling agent mapping.
  *********************************************/

  async deleteCountrySettlingAgentMappingDetails(data) {
    let status = await this.commonService.deleteAlertMsg()
    if (status) {
      this.spinner.show();
      let deleteUrl = this.commonVariablesService.baseURL + 'api/v1/marine_master/delete/country/' + data.country_id;
      let response = await this.commonService.httpPostMethod(deleteUrl, '', 'application/x-www-form-urlencoded; charset=UTF-8', true, 'Country Master');
      if (response.body.status == 0) {
        this.commonService.warningmsg('Country settling agent mapping data deleted successfully', 'Worning');
        this.loadCountrySettlingAgentMappingDetails();
        this.resetForm();
      }
      else if (response.body.status != -114) {
        this.commonService.errorsmsg('Unable to delete country settling agent mapping data', 'Error');
      }
    }
  }

  /*
  * Created By : Dinesh Kumar
  * Description : This function will upload the file in country settling agent mapping.
  *********************************************/

  async fileUpload(uploadedFile: FileList ) {
    if (uploadedFile.length == 0) {
      this.commonService.errorsmsg('No file chosen', 'Error');
      return;
    }

    this.spinner.show();
    let fileData = new FormData();
    fileData.append("file", uploadedFile.item(0));
    let url = this.commonVariablesService.baseURL + 'api/v1/marine_master/attach/bulk/country';
    let response = await this.commonService.httpPostMethod(url, fileData, '', true, 'Country Master');
    if (response.body.status == 0) {
      if (response.body.data.headers.length == 1) {
        this.commonService.errorsmsg('File mismatch, check column name', 'Error');
        return;
      }

      this.commonService.successmsg('Upload initiated', 'Success');
      let importUrl = this.commonVariablesService.baseURL + 'api/v1/marine_master/import/bulk/' + response.body.data.key;
      let params = new HttpParams()
        .set('import_table', 'country')
        .set('headers[0][column]', 'country_code')
        .set('headers[0][field]', 'country_code')
        .set('headers[0][ignore_errors]', 'true')
        .set('headers[0][skip_column]', 'false')
        .set('headers[1][column]', 'country_name')
        .set('headers[1][field]', 'country_name')
        .set('headers[1][ignore_errors]', 'true')
        .set('headers[1][skip_column]', 'false')
        .set('headers[2][column]', 'city_name')
        .set('headers[2][field]', 'city_name')
        .set('headers[2][ignore_errors]', 'true')
        .set('headers[2][skip_column]', 'false')
        .set('headers[3][column]', 'company_name')
        .set('headers[3][field]', 'company_name')
        .set('headers[3][ignore_errors]', 'true')
        .set('headers[3][skip_column]', 'false')
        .set('headers[4][column]', 'address')
        .set('headers[4][field]', 'address')
        .set('headers[4][ignore_errors]', 'true')
        .set('headers[4][skip_column]', 'false')
        .set('headers[5][column]', 'phone_no')
        .set('headers[5][field]', 'phone_no')
        .set('headers[5][ignore_errors]', 'true')
        .set('headers[5][skip_column]', 'false')
        .set('headers[6][column]', 'alt_phone_no')
        .set('headers[6][field]', 'alt_phone_no')
        .set('headers[6][ignore_errors]', 'true')
        .set('headers[6][skip_column]', 'false')
        .set('headers[7][column]', 'fax_no')
        .set('headers[7][field]', 'fax_no')
        .set('headers[7][ignore_errors]', 'true')
        .set('headers[7][skip_column]', 'false')
        .set('headers[8][column]', 'telex_no')
        .set('headers[8][field]', 'telex_no')
        .set('headers[8][ignore_errors]', 'true')
        .set('headers[8][skip_column]', 'false')
        .set('headers[9][column]', 'email_id')
        .set('headers[9][field]', 'email_id')
        .set('headers[9][ignore_errors]', 'true')
        .set('headers[9][skip_column]', 'false')
        .set('headers[10][column]', 'tabrowindx')
        .set('headers[10][field]', 'tabrowindx')
        .set('headers[10][ignore_errors]', 'true')
        .set('headers[10][skip_column]', 'false')
        .set('headers[11][column]', 'setling_agent_name')
        .set('headers[11][field]', 'setling_agent_name')
        .set('headers[11][ignore_errors]', 'true')
        .set('headers[11][skip_column]', 'false')
        .set('headers[12][column]', 'gc_country_name')
        .set('headers[12][field]', 'gc_country_name')
        .set('headers[12][ignore_errors]', 'true')
        .set('headers[12][skip_column]', 'false')
        .set('headers[13][column]', 'settling_agent_code')
        .set('headers[13][field]', 'settling_agent_code')
        .set('headers[13][ignore_errors]', 'true')
        .set('headers[13][skip_column]', 'false')
        .set('headers[14][column]', 'referral')
        .set('headers[14][field]', 'referral')
        .set('headers[14][ignore_errors]', 'true')
        .set('headers[14][skip_column]', 'false')
        .set('fields[country_code][name]', 'country_code')
        .set('fields[country_code][type]', 'varchar')
        .set('fields[country_code][size]', '10')
        .set('fields[country_code][null]', 'NO')
        .set('fields[country_code][defvalue]', '')
        .set('fields[country_code][mapped]', 'true')
        .set('fields[country_name][name]', 'country_name')
        .set('fields[country_name][type]', 'varchar')
        .set('fields[country_name][size]', '300')
        .set('fields[country_name][null]', 'NO')
        .set('fields[country_name][defvalue]', '')
        .set('fields[country_name][mapped]', 'true')
        .set('fields[city_name][name]', 'city_name')
        .set('fields[city_name][type]', 'varchar')
        .set('fields[city_name][size]', '300')
        .set('fields[city_name][null]', 'YES')
        .set('fields[city_name][defvalue]', '')
        .set('fields[city_name][mapped]', 'true')
        .set('fields[company_name][name]', 'company_name')
        .set('fields[company_name][type]', 'varchar')
        .set('fields[company_name][size]', '200')
        .set('fields[company_name][null]', 'NO')
        .set('fields[company_name][defvalue]', '')
        .set('fields[company_name][mapped]', 'true')
        .set('fields[address][name]', 'address')
        .set('fields[address][type]', 'varchar')
        .set('fields[address][size]', '500')
        .set('fields[address][null]', 'NO')
        .set('fields[address][defvalue]', '')
        .set('fields[address][mapped]', 'true')
        .set('fields[phone_no][name]', 'phone_no')
        .set('fields[phone_no][type]', 'varchar')
        .set('fields[phone_no][size]', '20')
        .set('fields[phone_no][null]', 'NO')
        .set('fields[phone_no][defvalue]', '')
        .set('fields[phone_no][mapped]', 'true')
        .set('fields[alt_phone_no][name]', 'alt_phone_no')
        .set('fields[alt_phone_no][type]', 'varchar')
        .set('fields[alt_phone_no][size]', '20')
        .set('fields[alt_phone_no][null]', 'YES')
        .set('fields[alt_phone_no][defvalue]', '')
        .set('fields[alt_phone_no][mapped]', 'true')
        .set('fields[fax_no][name]', 'fax_no')
        .set('fields[fax_no][type]', 'varchar')
        .set('fields[fax_no][size]', '20')
        .set('fields[fax_no][null]', 'YES')
        .set('fields[fax_no][defvalue]', '')
        .set('fields[fax_no][mapped]', 'true')
        .set('fields[telex_no][name]', 'telex_no')
        .set('fields[telex_no][type]', 'varchar')
        .set('fields[telex_no][size]', '20')
        .set('fields[telex_no][null]', 'YES')
        .set('fields[telex_no][defvalue]', '')
        .set('fields[telex_no][mapped]', 'true')
        .set('fields[email_id][name]', 'email_id')
        .set('fields[email_id][type]', 'varchar')
        .set('fields[email_id][size]', '100')
        .set('fields[email_id][null]', 'NO')
        .set('fields[email_id][defvalue]', '')
        .set('fields[email_id][mapped]', 'true')
        .set('fields[tabrowindx][name]', 'tabrowindx')
        .set('fields[tabrowindx][type]', 'varchar')
        .set('fields[tabrowindx][size]', '100')
        .set('fields[tabrowindx][null]', 'YES')
        .set('fields[tabrowindx][defvalue]', '')
        .set('fields[tabrowindx][mapped]', 'true')
        .set('fields[setling_agent_name][name]', 'setling_agent_name')
        .set('fields[setling_agent_name][type]', 'varchar')
        .set('fields[setling_agent_name][size]', '300')
        .set('fields[setling_agent_name][null]', 'NO')
        .set('fields[setling_agent_name][defvalue]', '')
        .set('fields[setling_agent_name][mapped]', 'true')
        .set('fields[gc_country_name][name]', 'gc_country_name')
        .set('fields[gc_country_name][type]', 'varchar')
        .set('fields[gc_country_name][size]', '200')
        .set('fields[gc_country_name][null]', 'NO')
        .set('fields[gc_country_name][defvalue]', '')
        .set('fields[gc_country_name][mapped]', 'true')
        .set('fields[settling_agent_code][name]', 'settling_agent_code')
        .set('fields[settling_agent_code][type]', 'varchar')
        .set('fields[settling_agent_code][size]', '200')
        .set('fields[settling_agent_code][null]', 'NO')
        .set('fields[settling_agent_code][defvalue]', '')
        .set('fields[settling_agent_code][mapped]', 'true')
        .set('fields[referral][name]', 'referral')
        .set('fields[referral][type]', 'varchar')
        .set('fields[referral][size]', '10')
        .set('fields[referral][null]', 'NO')
        .set('fields[referral][defvalue]', '')
        .set('fields[referral][mapped]', 'true');
      let uploadResponse = await this.commonService.httpPostMethod(importUrl, params, 'application/x-www-form-urlencoded; charset=UTF-8', true, 'Country Master');

      if (uploadResponse.body.status == 0) {
        this.commonService.successmsg('Upload successful', 'Success');
        this.loadCountrySettlingAgentMappingDetails();
        this.resetForm();
      }
      else if (uploadResponse.body.status != -114) {
        this.commonService.errorsmsg(uploadResponse.body.txt, 'Error');
      }
    }
    else {
      if (response.body.status == -103) {
        this.commonService.errorsmsg('Empty file / No data found against column name', 'Error');
      }
      else if (response.body.status != -114) {
        this.commonService.errorsmsg(response.body.txt, 'Error');
      }
    }
  }

  /*
  * Created By : Keerthana
  * Description : This function will reset in the country settling agent mapping.
  *********************************************/

  resetForm() {
    this.countrySettlingAgentMappingForm.reset();
    this.submitted = false;
    this.btnAddShow = false;
    this.btnUpdateShow = true;
  }

  /*
  * Created By : Keerthana
  * Description : This function will filter datatable according to search.
  *********************************************/

  filterBySearch() {
    let searchCountryCode = $("#searchCountryCode").val().toString().toLowerCase();
    let searchCountryName = $("#searchCountryName").val().toString().toLowerCase();
    let searchCityName = $("#searchCityName").val().toString().toLowerCase();
    let searchCompanyName = $("#searchCompanyName").val().toString().toLowerCase();
    let searchAddress = $("#searchAddress").val().toString().toLowerCase();
    let searchPhoneNo = $("#searchPhoneNo").val().toString().toLowerCase();
    let searchAlternatePhoneNo = $("#searchAlternatePhoneNo").val().toString().toLowerCase();
    let searchFaxNo = $("#searchFaxNo").val().toString().toLowerCase();
    let searchTelexNo = $("#searchTelexNo").val().toString().toLowerCase();
    let searchEmailId = $("#searchEmailId").val().toString().toLowerCase();
    let searchTabrowindx = $("#searchTabrowindx").val().toString().toLowerCase();
    let searchSettlingAgentName = $("#searchSettlingAgentName").val().toString().toLowerCase();
    let searchGCCountryName = $("#searchGCCountryName").val().toString().toLowerCase();
    let searchSettlingAgentCode = $("#searchSettlingAgentCode").val().toString().toLowerCase();
    let searchReferral = $("#searchReferral").val().toString().toLowerCase();
    let searchUpdatedBy = $("#searchUpdatedBy").val().toString().toLowerCase();
    let searchUpdatedTime = $("#searchUpdatedTime").val().toString().toLowerCase();

    let table = $("#countrySettlingAgentMappingDatatable").DataTable();
    table.search('').columns().search('').draw();

    if (searchCountryCode != "") {
      table.column(0).search(searchCountryCode).draw();
    }
    if (searchCountryName != "") {
      table.column(1).search(searchCountryName).draw();
    }
    if (searchCityName != "") {
      table.column(2).search(searchCityName).draw();
    }
    if (searchCompanyName != "") {
      table.column(3).search(searchCompanyName).draw();
    }
    if (searchAddress != "") {
      table.column(4).search(searchAddress).draw();
    }
    if (searchPhoneNo != "") {
      table.column(5).search(searchPhoneNo).draw();
    }
    if (searchAlternatePhoneNo != "") {
      table.column(6).search(searchAlternatePhoneNo).draw();
    }
    if (searchFaxNo != "") {
      table.column(7).search(searchFaxNo).draw();
    }
    if (searchTelexNo != "") {
      table.column(8).search(searchTelexNo).draw();
    }
    if (searchEmailId != "") {
      table.column(9).search(searchEmailId).draw();
    }
    if (searchTabrowindx != "") {
      table.column(10).search(searchTabrowindx).draw();
    }
    if (searchSettlingAgentName != "") {
      table.column(11).search(searchSettlingAgentName).draw();
    }
    if (searchGCCountryName != "") {
      table.column(12).search(searchGCCountryName).draw();
    }
    if (searchSettlingAgentCode != "") {
      table.column(13).search(searchSettlingAgentCode).draw();
    }
    if (searchReferral != "") {
      table.column(14).search(searchReferral).draw();
    }
    if (searchUpdatedBy != "") {
      table.column(15).search(searchUpdatedBy).draw();
    }
    if (searchUpdatedTime != "") {
      table.column(16).search(searchUpdatedTime).draw();
    }
  }
  /*
	* Created By : Priyadharshini
	* Description : Download sample excel format.
	*********************************************/
	downloadSampleFormat() {
		const fileName = 'country-settling-agent.csv'
		const dwldSampleUrl = `./assets/excel/${fileName}`;
		window.open(dwldSampleUrl, "_blank");		//To download the Document in new Tab
	}
	
	exportExcel()
	{
	   var tmpArray=[];
	   var tmpObj={};
	   
	   if(this.displayCountrySettlingAgentMappingResponse.length>0)
	   {
		 for(var i=0;i<this.displayCountrySettlingAgentMappingResponse.length;i++)
		 {
		  tmpObj={};
			tmpObj['country_code']=this.displayCountrySettlingAgentMappingResponse[i].country_code;
			tmpObj['country_name']=this.displayCountrySettlingAgentMappingResponse[i].country_name;
			tmpObj['city_name']=this.displayCountrySettlingAgentMappingResponse[i].city_name;
			tmpObj['company_name']=this.displayCountrySettlingAgentMappingResponse[i].company_name;
			tmpObj['address']=this.displayCountrySettlingAgentMappingResponse[i].address;
			tmpObj['phone_no']=this.displayCountrySettlingAgentMappingResponse[i].phone_no;
			tmpObj['alt_phone_no']=this.displayCountrySettlingAgentMappingResponse[i].alt_phone_no;
			tmpObj['fax_no']=this.displayCountrySettlingAgentMappingResponse[i].fax_no;
			tmpObj['telex_no']=this.displayCountrySettlingAgentMappingResponse[i].telex_no;
			tmpObj['email_id']=this.displayCountrySettlingAgentMappingResponse[i].email_id;
			tmpObj['tabrowindx']=this.displayCountrySettlingAgentMappingResponse[i].tabrowindx;
			tmpObj['setling_agent_name']=this.displayCountrySettlingAgentMappingResponse[i].setling_agent_name;
			tmpObj['gc_country_name']=this.displayCountrySettlingAgentMappingResponse[i].gc_country_name;
			tmpObj['settling_agent_code']=this.displayCountrySettlingAgentMappingResponse[i].settling_agent_code;
			tmpObj['referral']=this.displayCountrySettlingAgentMappingResponse[i].referral;
			tmpObj['author']=this.displayCountrySettlingAgentMappingResponse[i].author;
			tmpObj['u_ts']=this.displayCountrySettlingAgentMappingResponse[i].u_ts;
			tmpArray.push(tmpObj)
		 }
		 var datajson= { datajson1: tmpArray };

		 var Heading = [
		   [],
		   ["Country Settling Agent Mapping Master"],
		   [],
		   ["Country Code","Country Name","City Name","Company Name","Address","Phone No","Alternate Phone No","Fax No","Telex No","Email ID","Tabrowindx","Settling Agent Name","GC Country Name","Settling Agent Code","Referral","Updated By","Updated Time"]
		 ];

		 const merge = [
			 { s: { r: 0, c: 0 }, e: { r: 0, c: 18 } },
			 { s: { r: 1, c: 0 }, e: { r: 1, c: 18 } },
			 { s: { r: 2, c: 0 }, e: { r: 2, c: 18 } },
			 /* { s: { r: 3, c: 0 }, e: { r: 3, c: 3 } }, */
		 ];
		 
		 var wscols = [];
		 //let cell;
		 for (let idx = 0; idx < Heading[3].length; idx++) 
		 {
			 wscols.push({ wch: 25 });  // Common column width
		 }
		 var ws = XLSX.utils.json_to_sheet(Heading);
		 ws['!cols'] = wscols;
		 ws["!merges"] = merge;
		 ws["A1"] = {
			 "t": 's',
			 /* "v": 'TATA MARINE', */
			 "s": { font: { size: 20, bold: true, color: "#e012e0", style: "text-align:center"} }
		 };
		 XLSX.utils.sheet_add_json(ws, datajson.datajson1, {
			 /* header: ["group_name","author","u_ts"], */
			 skipHeader: true,
			 origin: -1
		 });
		 // var alphabets = [''];
		 var wb = XLSX.utils.book_new();
		 XLSX.utils.book_append_sheet(wb, ws, "Country Settling Master");
		 XLSX.writeFile(wb, 'Country_Settling_Master.xlsx');
	   }
	   else
	   {
		this.commonService.errorsmsg("Unable to download excel,No data available in the table","Error"); 
	   }
   }
   
  /*
	* Created By : Sharann
	* Description : check the data before add/update.
	*********************************************/
	checkCountryMappingMasterData() {
    if (this.countrySettlingAgentMappingForm.invalid) {
      this.submitted = true;
      return false;
    }
    else {
      this.countrySettlingAgentMappingFormValue = this.countrySettlingAgentMappingForm.value;

      if ((this.countrySettlingAgentMappingFormValue.countryCode).trim() == "") {
        this.commonService.errorsmsg("Invalid Parameter, Missing country code", 'Error');
        return false;
      }
      else if ((this.countrySettlingAgentMappingFormValue.countryName).trim() == "") {
        this.commonService.errorsmsg("Invalid Parameter, Missing country name", 'Error');
        return false;
      }
      else if ((this.countrySettlingAgentMappingFormValue.companyName).trim() == "") {
        this.commonService.errorsmsg("Invalid Parameter, Missing company name", 'Error');
        return false;
      }
      else if ((this.countrySettlingAgentMappingFormValue.address).trim() == "") {
        this.commonService.errorsmsg("Invalid Parameter, Missing address", 'Error');
        return false;
      }
      else if ((this.countrySettlingAgentMappingFormValue.phoneNo).trim() == "") {
        this.commonService.errorsmsg("Invalid Parameter, Missing phone number", 'Error');
        return false;
      }
      else if ((this.countrySettlingAgentMappingFormValue.emailId).trim() == "") {
        this.commonService.errorsmsg("Invalid Parameter, Missing email Id", 'Error');
        return false;
      }
      else if ((this.countrySettlingAgentMappingFormValue.settling_Agent_Name).trim() == "") {
        this.commonService.errorsmsg("Invalid Parameter, Missing settling agent name", 'Error');
        return false;
      }
      else if ((this.countrySettlingAgentMappingFormValue.GC_country_name).trim() == "") {
        this.commonService.errorsmsg("Invalid Parameter, Missing GC country name", 'Error');
        return false;
      }
      else if ((this.countrySettlingAgentMappingFormValue.settling_Agent_Code).trim() == "") {
        this.commonService.errorsmsg("Invalid Parameter, Missing settling agent code", 'Error');
        return false;
      }
      return true;
    }
  }
}
